import classNames from 'classnames'
import toast from 'cogo-toast'
import { RemoveUserElementType } from 'globalTypes'

import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans, t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import RemoveElement from 'Root/App/Card/RemoveElement'

import styles from '../index.module.css'

const Remove = ({ id, typename }) => {
  const { i18n } = useLingui()

  const onRemoveCallback = () =>
    toast.warn(
      <div className="flex flex-col gap-3">
        <div>{t(i18n)`Elemento rimosso.`}</div>
      </div>
    )

  return (
    <Menu.Item>
      {({ active, ...props }) => (
        <RemoveElement
          {...props}
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item,
            'group'
          )}
          elementId={id}
          elementTypename={typename}
          type={RemoveUserElementType.collection}
          callback={onRemoveCallback}
        >
          <FontAwesomeIcon className={styles.icon} icon={faCircleXmark} />
          <Trans>Rimuovi</Trans>
        </RemoveElement>
      )}
    </Menu.Item>
  )
}

export default Remove
